export function GradientBackground({ showGrid = true }: { showGrid?: boolean } = {}) {
  return (
    <div aria-hidden="true" className="theme-gradient-background pointer-events-none fixed inset-0 overflow-hidden bg-slate-950">
      {showGrid && (
        <div
          className="absolute inset-0 opacity-55"
          style={{
            backgroundImage: [
              'linear-gradient(rgb(var(--theme-grid) / 0.12) 1px, transparent 1px)',
              'linear-gradient(90deg, rgb(var(--theme-grid) / 0.12) 1px, transparent 1px)',
            ].join(', '),
            backgroundSize: '48px 48px',
          }}
        />
      )}
      <div className="theme-gradient-overlay absolute inset-0" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-200/70 to-transparent" />
      <div className="absolute -left-28 top-24 h-80 w-80 rounded-full bg-[rgb(var(--theme-highlight)/0.055)] blur-3xl sm:-left-44 sm:top-10 sm:h-[30rem] sm:w-[30rem] sm:bg-[rgb(var(--theme-highlight)/0.1)]" />
      <div className="absolute -right-28 top-72 h-80 w-80 rounded-full bg-[rgb(var(--theme-secondary)/0.035)] blur-3xl sm:-right-44 sm:top-20 sm:h-[30rem] sm:w-[30rem] sm:bg-[rgb(var(--theme-secondary)/0.055)]" />
      <div className="hidden sm:block absolute bottom-10 left-1/2 h-[26rem] w-[26rem] -translate-x-1/2 rounded-full bg-[rgb(var(--theme-primary)/0.035)] blur-3xl" />
    </div>
  );
}
